import {Component} from '@angular/core';

@Component({
  selector: 'ngx-app',
  styleUrls: ['app.component.scss'],
  template: `
    <router-outlet></router-outlet>
  `,
})
export class AppComponent {
}
